import {WidgetCategoryBox} from "../../organisms/widget--category-box";
import classNames from "classnames";

export function ParagraphCategoryBox({paragraph, ...props}) {
  if (!paragraph?.field_cb_pg_items?.length) return <></>;

  return (
    <div className={classNames(
      "paragraph--category-box bg-white text-center h-full rounded-md flex flex-col justify-between",
      {"drop-shadow-sm": !paragraph?.field_category_box_hide_shadow},
    )}>
        {paragraph.field_cb_pg_items.map((item, key) => (
          <WidgetCategoryBox
            key={`${paragraph.id}-${key}`}
            title={item?.field_cbi_display_title?.length ? item?.field_cbi_display_title : item?.field_cbi_title ?? item.title ?? ""}
            description={item?.field_cbi_description.value ?? ""}
            buttons={item?.field_cbi_button ?? []}
            image={item?.field_cbi_image}
            {...props}
          />
        ))}
    </div>
  )
}
